module.exports = __webpack_public_path__ + "static/media/Cubone_gaussian2.e349c395.png";